import { render, staticRenderFns } from "./AppConfigRules.vue?vue&type=template&id=040ac857"
import script from "./AppConfigRules.vue?vue&type=script&lang=js"
export * from "./AppConfigRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports